import React from "react";
import { FooterRow } from "./copyright";

export const Footer = () => {
  return (
    <React.Fragment>
      <div className="footer-main">
        <FooterRow />
      </div>
    </React.Fragment>
  );
};
